import React from 'react';

export const DecisionNew = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.60547 3.66602L16.8879 4.82808"
      stroke={color || '#615E84'}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.46484 17.5488H13.0272"
      stroke={color || '#615E84'}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M2.86133 13.7118H7.86133L6.07341 3.94074L4.68933 3.83496L2.86133 13.7118Z"
      stroke={color || '#615E84'}
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6309 14.5966H17.6309L15.8429 4.82551L14.4589 4.71972L12.6309 14.5966Z"
      stroke={color || '#615E84'}
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.2461 3.18848V17.5492"
      stroke={color || '#615E84'}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
